export const getOrganizationUrlFromSlug = (slug: string, url?: string) => {
    if(!slug) {
        return url || '/';
    }

    const _url = url ? url.startsWith('/') ? url : `/${url}` : '/';
    const domain = process.env.NEXT_PUBLIC_TACTIC_DOMAIN || '';
    let port = String(process.env.NEXT_PUBLIC_TACTIC_PORT || '');
    if(port && port !== '80' && port !== '443') {
        port = port ? `:${port}` : '';
    }

    return `${process.env.NEXT_PUBLIC_TACTIC_SCHEME}://${slug}.${domain}${port}${_url}`;
}